/* eslint-disable no-unused-vars */
import Vue from 'vue';
import Vuex from 'vuex';
//import pathify from 'vuex-pathify'
//import LoyaltyHubStore from './modules/loyaltyhub.module';
import axios from "axios";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)
const apiURL = process.env.VUE_APP_LOYALTY_API_URI;

export default new Vuex.Store({
  //plugins: [ pathify.plugin ], // activate plugin
  state: {
    auth: {},
    category: [],
    subCategory: [],
    package: [],
    products: [],
    point: [],
    rewards: [],
    privileges: [],
    tierPrivilege: [],
    totalItems: 0,
    saleProduct: [],
    sales: {},
    salesList: [],
    redeemList: [],
    redeem: {
      pending: {},
      list: {},
      reward: []
    },
    redeemReward: [],
    config: {},
    qrPointList: [],
  },
  getters: {
    getSaleProduct(state) {
      return state.saleProduct || [];
    },
    is_auth() {
      console.log(sessionStorage.getItem("custId"))
      //console.log(sessionStorage.getItem("apiKey"))

      return sessionStorage.getItem("custId") ? true : false
    },
    getCategory(state) {
      return state.category;
    },

    getSubCategory(state) {
      return state.subCategory;
    },

    getPackage() {
      return JSON.parse(sessionStorage.getItem("package"));
    },

    //qr point
    getQRPointsList(state){
        console.log('getQRPointsList');
        console.log(state);
        return state.qrPointList;
    },

    // reward
    getAllRewards(state) {
      return state.rewards;
    },
    // privilege
    getAllPrivileges(state) {
      return state.privileges;
    },


  },
  mutations: {
    SET_USER_AUTH: async (state, payload) => {
      state.auth = sessionStorage.getItem("apiKey") ? true : false
    },
    LOGOUT: (state) => {
      /*
          sessionStorage.setItem("user",null);
          sessionStorage.setItem("apiKey",null);
          sessionStorage.setItem("token",null);
      */
      sessionStorage.clear();
    },

    //-------------------- PRODUCT / CATEGORY
    SET_PRODUCTS: (state, payload) => {
      state.products = payload
    },
    ADD_CATEGORY: (state, payload) => {
      state.category.push(payload);
    },

    ADD_SUB_CATEGORY: (state, payload) => {
      state.subCategory.push(payload);
    },

    UPDATE_CATEGORY: (state, payload) => {
      //state.category.push(payload);
      console.log('UPDATE_CATEGORY');

      const index = state.category.findIndex(category => category._id === payload._id);

      if (index !== -1) {
        state.category.splice(index, 1, payload);
      }
    },

    UPDATE_SUB_CATEGORY: (state, payload) => {
      const index = state.subCategory.findIndex(category => category._id === payload._id);

      if (index !== -1) {
        state.subCategory.splice(index, 1, payload);
      }
    },

    REMOVE_CATEGORY: (state, id) => {
      state.category = state.category.filter((category) => category._id !== id)
    },

    REMOVE_SUBCATEGORY: (state, id) => {
      state.subCategory = state.subCategory.filter((category) => category._id !== id)
    },

    SET_CATEGORY_LIST: (state, payload) => {
      state.category = payload;
    },
    SET_SUBCATEGORY_LIST: (state, payload) => {
      state.subCategory = payload;
    },


    SET_REWARDS_LIST: (state, payload) => {
      state.rewards = payload;
    },

    UPDATE_REWARD: (state, data) => {

      // console.log("UPDATE REWARD");
      // console.log(data);
      Vue.set(state.rewards, data.index, data.value);

      //state.rewards[data.index] = data.value;
      //console.log(state.rewards);
    },

    ADD_REWARD: (state, data) => {
      //Vue.set(state.rewards,state.rewards.length,data);
      console.log("ADD REWARD");

      state.rewards.push(data);
      console.log(state.rewards);
    },
    // QR Point
    SET_QR_POINT_LIST: (state, payload) => {
      console.log("--------SET_QR_POINT_LIST-------------");
      console.log(payload);
      state.qrPointList = payload;
      //console.log(state.qrPointList);
    },

    // Privileges
    SET_PRIVILEGES_LIST: (state, payload) => {
      state.privileges = payload;
    },

    UPDATE_PRIVILEGE: (state, data) => {

      // console.log("UPDATE PRIVILEGE");
      // console.log(data);
      Vue.set(state.privileges, data.index, data.value);

      //state.privileges[data.index] = data.value;
      //console.log(state.privileges);
    },

    ADD_PRIVILEGE: (state, data) => {
      //Vue.set(state.privileges,state.privileges.length,data);
      console.log("ADD PRIVILEGE");

      state.privileges.push(data);
      console.log(state.privileges);
    },


    // Tier Privileges
    SET_TIER_PRIVILEGES_LIST: (state, payload) => {
      state.tierPrivilege = payload;
    },

    UPDATE_TIER_PRIVILEGE: (state, data) => {

      // console.log("UPDATE PRIVILEGE");
      // console.log(data);
      Vue.set(state.tierPrivilege, data.index, data.value);

      //state.tierPrivilege[data.index] = data.value;
      //console.log(state.tierPrivilege);
    },

    ADD_TIER_PRIVILEGE: (state, data) => {
      //Vue.set(state.tierPrivilege,state.tierPrivilege.length,data);
      console.log("ADD PRIVILEGE");

      state.tierPrivilege.push(data);
      console.log(state.tierPrivilege);
    },


    // total items
    SET_TOTAL_ITEMS: (state, total) => {
      state.totalItems = total;
    },

    // sale
    ADD_SALE_PRODUCT: (state, payload) => {
      state.saleProduct.push(payload)
    },
    REMOVE_SALE_PRODUCT: (state, index) => {
      console.log("REMOVE_SALE_PRODUCT");
      console.log(index);
      if (index == 0) { state.saleProduct.shift() } else { state.saleProduct.splice(index, 1) }
      console.log(state.saleProduct)
    },
    SET_SALE_PRODUCT: (state, payload) => {
      state.saleProduct = payload
    },
    RESET_SALE_PRODUCT: (state) => {
      state.saleProduct = {}
    },
    UPDATE_SALE_PRODUCT: (state, { payload, index }) => {
      Vue.set(state.saleProduct, index, payload);
    },
    SET_TEMP_SALE: (state, payload) => {
      state.sales = payload
    },
    RESET_TEMP_SALE: (state) => {
      state.sales = {}
    },
    UPDATE_SALES_STATUS: (state, payload) => {
      state.sales.status = payload
    },
    SET_SALES_LIST: (state, payload) => {
      state.salesList = payload
    },
    RESET_SALES_LIST: (state) => {
      state.salesList = []
    },
    REMOVE_SALES_LIST: (state, index) => {
      console.log("REMOVE_SALES_LIST");
      console.log(index);
      if (index == 0) { state.salesList.shift() } else { state.salesList.splice(index, 1) }
      console.log(state.salesList)
    },
    //redeem
    SET_PENDING_REDEEM: (state, payload) => {
      state.redeem.pending = payload
    },
    ADD_REDEEM_REWARD: (state, payload) => {
      state.redeemReward.push(payload)
    },
    REMOVE_REDEEM_REWARD: (state, index) => {
      //alert(index)
      if (index == 0) { state.redeemReward.shift() } else { state.redeemReward.splice(index, 1) }
      console.log(state.redeemReward)
    },
    SET_REDEEM_REWARD: (state, payload) => {
      state.redeemReward = payload
    },
    RESET_REDEEM_REWARD: (state) => {
      state.redeemReward = {}
    },
    UPDATE_REDEEM_REWARD: (state, { payload, index }) => {
      Vue.set(state.redeemReward, index, payload);
    },
    SET_TEMP_REDEEM: (state, payload) => {
      state.redeems = payload
    },
    RESET_TEMP_REDEEM: (state) => {
      state.redeems = {}
    },
    UPDATE_REDEEM_STATUS: (state, payload) => {
      state.redeems.status = payload
    },
    SET_REDEEM_LIST: (state, payload) => {
      console.log(payload)
      state.redeemList = payload
    },
    RESET_REDEEM_LIST: (state) => {
      state.redeemList = []
    },
    // config
    SET_CONFIG: (state, data) => {
      if (data !== undefined) {
        state.config = data
      }
    }

  },
  actions: {
    setUserAuth: async ({ commit }, payload) => {
      commit('SET_USER_AUTH', payload)
    },
    logout: ({ commit }) => {
      commit('LOGOUT', "")
    },


    // category
    addCategory: async ({ commit }, payload) => {
      commit("ADD_CATEGORY", payload);
    },
    addSubCategory: async ({ commit }, payload) => {
      commit("ADD_SUB_CATEGORY", payload);
    },
    updateCategory: async ({ commit }, payload) => {
      commit("UPDATE_CATEGORY", payload);
    },
    updateSubCategory: async ({ commit }, payload) => {
      commit("UPDATE_SUB_CATEGORY", payload);
    },
    setCategoryList: async ({ commit }) => {
      //console.log(apiKey)

      const list = await axios.get(apiURL + '/v1/category/list?custId=' + sessionStorage.getItem("custId"))

      console.log(list)

      commit("SET_CATEGORY_LIST", list.data.data);
    },
    setSubCategoryList: async ({ commit, state }) => {
      //console.log(apiKey)
      console.log('setSubCategoryList')
      const list = await axios.get(apiURL + '/v1/subcategory/list?custId=' + sessionStorage.getItem("custId"))

      console.log(list)
      commit("SET_SUBCATEGORY_LIST", list.data.data);
    },
    deleteCategoryList: async ({ commit }, id) => {
      commit("REMOVE_CATEGORY_LIST", id);
    },
    deleteSubCategoryList: async ({ commit }, id) => {
      commit("REMOVE_SUBCATEGORY_LIST", id);
    },

    //product
    setProducts: async ({ commit }, payload) => {
      commit("SET_PRODUCTS", payload)
    },


    // Rewards

    setRewardsList: async ({ commit }, payload) => {
      try {
        const list = await axios.get(apiURL + '/v1/rewards/list', { params: payload })
        console.log('set rewards list');
        console.log(list);
        commit("SET_REWARDS_LIST", list.data.data);
        commit("SET_TOTAL_ITEMS", list.data.totalItems);
        return "";
      }
      catch (err) {
        return err
      }

    },

    addRewards: async ({ commit, state }, payload) => {
      try {
        //
        await axios
          .post(
            apiURL + "/v1/rewards/create",
            payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                token: sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            //console.log(response)
            //state.rewards.push(response.data.data);
            if (response.status == 200) {
              commit("ADD_REWARD", response.data)
              commit("SET_TOTAL_ITEMS", state.totalItems + 1)
            } //else {
            return response;
            //}
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (err) {
        return err;
      }
    },


    updateRewards: async ({ commit }, payload) => {
      try {
        //
        await axios
          .put(
            apiURL + "/v1/rewards/update",
            payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                token: sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            //state.rewards.push(response.data.data);
            // console.log(response);
            // console.log(payload);
            if (response.status == 200) {
              commit("UPDATE_REWARD", { index: payload.index, value: response.data[0] })
            } //else {
            //console.log(response.data);
            return response;
            //}

            //commit("SET_TOTAL_ITEMS", state.totalItems+1)
          })
          .catch((error) => {
            return error
          });
      } catch (err) {
        return err;
      }
    },
    deleteRewards: ({ commit }, payload) => {

    },


    // QR Point

    setQRPointsList: async ({ commit }, payload) => {
      try {
        const list = await axios.get(apiURL + '/v1/point/qr-point-list', { params: payload })
        console.log('set qr point list');
        console.log(list);
        commit("SET_QR_POINT_LIST", list.data.data);
        commit("SET_TOTAL_ITEMS", list.data.totalItems);
        return "";
      }
      catch (err) {
        return err
      }

    },


    // Privileges

    setPrivilegesList: async ({ commit }, payload) => {
      try {
        const list = await axios.get(apiURL + '/v1/privileges/list', { params: payload })
        console.log('set privileges list');
        console.log(list);
        commit("SET_PRIVILEGES_LIST", list.data.data);
        commit("SET_TOTAL_ITEMS", list.data.totalItems);
        return "";
      }
      catch (err) {
        return err
      }

    },

    addPrivileges: async ({ commit, state }, payload) => {
      try {
        //
        await axios
          .post(
            apiURL + "/v1/privileges/create",
            payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                token: sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            //console.log(response)
            //state.privileges.push(response.data.data);
            if (response.status == 200) {
              commit("ADD_PRIVILEGE", response.data)
              commit("SET_TOTAL_ITEMS", state.totalItems + 1)
            } //else {
            return response;
            //}
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (err) {
        return err;
      }
    },


    updatePrivileges: async ({ commit }, payload) => {
      try {
        //
        await axios
          .put(
            apiURL + "/v1/privileges/update",
            payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                token: sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            //state.privileges.push(response.data.data);
            // console.log(response);
            // console.log(payload);
            if (response.status == 200) {
              commit("UPDATE_PRIVILEGE", { index: payload.index, value: response.data[0] })
            } //else {
            //console.log(response.data);
            return response;
            //}

            //commit("SET_TOTAL_ITEMS", state.totalItems+1)
          })
          .catch((error) => {
            return error
          });
      } catch (err) {
        return err;
      }
    },
    deletePrivileges: ({ commit }, payload) => {

    },



    // TierPrivileges

    setTierPrivilegesList: async ({ commit }, payload) => {
      try {
        const list = await axios.get(apiURL + '/v1/tier-privileges/list', { params: payload })
        console.log('set privileges list');
        console.log(list);
        commit("SET_TIER_PRIVILEGES_LIST", list.data.data);
        commit("SET_TOTAL_ITEMS", list.data.totalItems);
        return list.data.data;
      }
      catch (err) {
        return err
      }

    },

    getTierPrivilegesList: async ({ commit }, payload) => {
      try {
        const list = await axios.get(apiURL + '/v1/tier-privileges/privilege/' + payload.privilegeId, { params: payload })
        console.log('set privileges list');
        console.log(list.data.data);
        commit("SET_TIER_PRIVILEGES_LIST", list.data.data);
        commit("SET_TOTAL_ITEMS", list.data.totalItems);
        return list.data.data;
      }
      catch (err) {
        return err
      }

    },

    addTierPrivileges: async ({ commit, state }, payload) => {
      try {
        //
        await axios
          .post(
            apiURL + "/v1/tier-privileges/create",
            payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                token: sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            //console.log(response)
            //state.privileges.push(response.data.data);
            if (response.status == 200) {
              commit("ADD_TIER_PRIVILEGE", response.data)
              commit("SET_TOTAL_ITEMS", state.totalItems + 1)
            } //else {
            return response;
            //}
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (err) {
        return err;
      }
    },


    updateTierPrivileges: async ({ commit }, payload) => {
      try {
        //
        await axios
          .put(
            apiURL + "/v1/tier-privileges/update",
            payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                token: sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            //state.privileges.push(response.data.data);
            // console.log(response);
            // console.log(payload);
            if (response.status == 200) {
              commit("UPDATE_TIER_PRIVILEGE", { index: payload.index, value: response.data[0] })
            } //else {
            //console.log(response.data);
            return response;
            //}

            //commit("SET_TOTAL_ITEMS", state.totalItems+1)
          })
          .catch((error) => {
            return error
          });
      } catch (err) {
        return err;
      }
    },
    deleteTierPrivileges: ({ commit }, payload) => {

    },


    // total Items
    setTotalItems: ({ commit }, payload) => {
      commit("SET_TOTAL_ITEMS", payload);
    },

    //sale
    addSaleProduct: ({ commit }, payload) => {
      commit("ADD_SALE_PRODUCT", payload)
    },
    updateSaleProduct: ({ commit }, { payload, index }) => {
      commit("UPDATE_SALE_PRODUCT", { payload, index })
    },
    removeSaleProduct: ({ commit }, index) => {
      commit("REMOVE_SALE_PRODUCT", index)
    },
    setSaleProduct: ({ commit }, payload) => {
      commit("SET_SALE_PRODUCT", payload)
    },
    setSales: ({ commit }, payload) => {
      commit("SET_TEMP_SALE", payload)
    },
    updateSalesStatus: ({ commit }, status) => {
      commit("UPDATE_SALES_STATUS", status)
    },
    resetSales: ({ commit }) => {
      commit("RESET_TEMP_SALE")
    },
    setSalesList: ({ commit }, payload) => {

      commit("SET_SALES_LIST", payload)
    },
    resetSalesList: ({ commit }) => {
      commit("RESET_SALES_LIST")
    },
    removeSalesList: ({ commit }, index) => {
      commit("REMOVE_SALES_LIST", index)
    },
    resetSalesProduct: ({ commit }) => {
      commit("RESET_SALE_PRODUCT")
    },
    //redeem
    setPendingRedeem: ({ commit }, payload) => {
      commit("SET_PENDING_REDEEM", payload)
    },
    addRedeemProduct: ({ commit }, payload) => {
      commit("ADD_REDEEM_REWARD", payload)
    },
    updateRedeemProduct: ({ commit }, { payload, index }) => {
      commit("UPDATE_REDEEM_REWARD", { payload, index })
    },
    removeRedeemProduct: ({ commit }, index) => {
      commit("REMOVE_REDEEM_REWARD", index)
    },
    setRedeemProduct: ({ commit }, payload) => {
      commit("SET_REDEEM_REWARD", payload)
    },
    setRedeem: ({ commit }, payload) => {
      commit("SET_TEMP_REDEEM", payload)
    },
    updateRedeemStatus: ({ commit }, status) => {
      commit("UPDATE_REDEEM_STATUS", status)
    },
    resetRedeem: ({ commit }) => {
      commit("RESET_TEMP_REDEEM")
    },
    setRedeemList: ({ commit }, payload) => {
      commit("SET_REDEEM_LIST", payload)
    },
    resetRedeemList: ({ commit }) => {
      commit("RESET_REDEEM_LIST")
    },
    resetRedeemProduct: ({ commit }) => {
      commit("RESET_REDEEM_REWARD")
    },

    //config
    // config
    getConfig: async ({ commit }, payload) => {
      //
      console.log('getConfig')
      try {

        await axios
          .post(
            apiURL + "/v1/admin/getConfigByName",
            payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            console.log(response)
            //this.pointType = response.data.value;
            //return response.data;
            if (response.data[0] !== undefined) {
              commit("SET_CONFIG", response.data[0])
            }
          });
      } catch (err) {
        console.log(err)
      }
    },


  },
  modules: {
    //BFC
  },
  plugins: [createPersistedState()]
})
